import { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

// Webpack mangles leaflet's default icon paths — fix them explicitly
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

// MapContainer's center prop is set once on mount; this child moves the view
// whenever the parent passes new coordinates.
function MapUpdater({ latitude, longitude }) {
  const map = useMap();
  useEffect(() => {
    map.setView([latitude, longitude], 14);
  }, [latitude, longitude, map]);
  return null;
}

const MapSection = ({ latitude, longitude, showMap }) => {
  return (
    <section className="map-section">
      {showMap && (
        <div className="map-container">
          <MapContainer
            center={[latitude, longitude]}
            zoom={14}
            style={{ width: '100%', height: 325 }}
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />
            <Marker position={[latitude, longitude]} />
            <MapUpdater latitude={latitude} longitude={longitude} />
          </MapContainer>
        </div>
      )}
    </section>
  );
};

export default MapSection;
